import url from './url';



export default url(() => '/local-notifications');
